import { Alignment, Button, Classes, Colors, Navbar } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";
import { useHistory } from "react-router";
import styled from "styled-components";

import { ERoutes } from "../AppRouter";
import assets from "../assets";
import { BreadcrumbContext } from "../contexts";
import { AppBreadcrumb } from "./AppBreadcrumb";
import { LanguageSelector } from "./LanguageSelector";
import { UserMenu } from "./UserMenu";
import { ETLCodes } from "../locales";
import { useRouter, useTl } from "../hooks";

interface IHeaderProps {
  showMenuIcon: boolean;
  toggleLeftMenu?: () => void;
  isDark?: boolean;
  onDarkSwitchChange?: (e: boolean) => void;
}

const NavBarStyled = styled(Navbar)`
  /* background-image: linear-gradient(to right,#0E5A8A,#0E5A8A 25%,rgba(255, 255, 255, 0.5),white 65%,#0E5A8A 80%), url(${assets
    .images.nsiLogo}) !important; */
  /* background-position: 0% 35%; */
  height: 50px !important;
  padding-left: 0 !important;
  background-color: ${Colors.DARK_GRAY3} !important;

  & > .${Classes.NAVBAR_GROUP} {
    height: 50px;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  min-width: 224px;
  text-align: center;
  height: 100%;

  &:hover {
    cursor: pointer;
  }
`;
const HeaderText = styled.div`
  font-size: 1.2rem;
  font-weight: bold;
`;

const LogoImage = styled.img`
  background-color: ${Colors.WHITE};
  height: 40px;
  border-radius: 5px;
  margin-left: 5px;
  padding-left: 20px;
  padding-right: 20px;
`;

export const Header: React.FC<IHeaderProps> = (props) => {
  const { breadcrumbs } = React.useContext(BreadcrumbContext);
  const { push } = useHistory();
  const { location } = useRouter();
  const { t } = useTl();

  const goToPublicUrl = () => {
    window.open(document.location.origin + "/index-public.html");
  };

  return (
    <div className={Classes.DARK}>
      <NavBarStyled>
        <Navbar.Group align={Alignment.LEFT} style={{ width: 294 }}>
          {props.toggleLeftMenu && props.showMenuIcon && (
            <>
              <Button
                icon={IconNames.MENU}
                minimal={true}
                onClick={props.toggleLeftMenu}
              />
              <Navbar.Divider />
            </>
          )}
          <LogoContainer style={{}} onClick={() => push(`${ERoutes.home}`)}>
            <LogoImage src={assets.images.logoIfic} alt="logo" />
            <Navbar.Divider />
            <HeaderText>Afosoc-Ific</HeaderText>
          </LogoContainer>
        </Navbar.Group>
        <Navbar.Group align={Alignment.LEFT}>
          <Navbar.Heading>
            <AppBreadcrumb items={breadcrumbs} />
          </Navbar.Heading>
        </Navbar.Group>
        <Navbar.Group align={Alignment.RIGHT}>
          <Button
            text={t(ETLCodes.Public)}
            minimal={true}
            onClick={goToPublicUrl}
            icon={"document-open"}
          ></Button>
          <LanguageSelector />
          <UserMenu />
        </Navbar.Group>
      </NavBarStyled>
    </div>
  );
};
